import { default as scroll } from "./base/_scroll.js";
import { default as mainMenus } from "./modules/_main-menu.js";
import { default as fonts } from "./base/_fonts.js";

(function() {
  fonts.init();
  scroll.init();
  mainMenus.init();
})();
